import React, { useEffect, useState } from "react";
import {makeStyles} from '@material-ui/core/styles';
import { Dialog, Slide, AppBar, Toolbar, Typography, IconButton } from '@mui/material/';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';


// import { Document, Page, pdfjs } from "react-pdf";


// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// const options = {
//     cMapUrl: 'cmaps/',
//     cMapPacked: true,
// };


// 1053577
const EmberFile = props => {
    // const [file, setFile] = useState('./sample.pdf');

    const { expediente, setExpediente } = props;
    console.log(expediente)
    const classes = useStyles();
    const [open, setOpen] = useState(props.expediente);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber] = useState(1);
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };
    useEffect(() => {
        console.log('3666666666666')
      }, [expediente]);
    return (
        <div>
            <Dialog
                fullScreen
                open={!!expediente}
                onClose={() => setExpediente(undefined)}
                TransitionComponent={Transition}
            >
                <AppBar position="static">
                    <Toolbar>

                        <Typography color="inherit" className={classes.flex} />

                        <IconButton onClick={() => setExpediente(undefined)} color="inherit" size="large">
                            <ExitToAppOutlinedIcon />
                            <Typography color="inherit" className={classes.textTitle} >
                                Cerrar
                            </Typography>
                        </IconButton>

                    </Toolbar>
                </AppBar>
                {/* <div className="SuperPDF">
                    <div className="SuperPDF__container">
                        <div className="SuperPDF__container__document">
                            <Document file='sample.pdf' onLoadSuccess={onDocumentLoadSuccess} options={options}>
                                {Array.from(new Array(numPages), (el, index) => (
                                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                                ))}
                            </Document>
                        </div>
                    </div>
                </div> */}
                <div className={classes.containerIframe}>
                    <iframe
                    className={classes.responsiveIframe}
                    src={expediente}
                    title="Expediente"
                    />
                </div>
            </Dialog>
        </div>
    );
}

export default EmberFile;

const useStyles = makeStyles(() => ({
    containerIframe: {
        position: "relative",
        width: "100%",
        overflow: "hidden",
        paddingTop: "100%"
    },
    responsiveIframe: {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: "100%",
        height: "100%",
        border: "none"
    },
    appBar: {
        background: '#fff'
    },
    flex: {
        flexGrow: 1,
    },
}))